import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-no-params',
  template: `<div></div>`
})
export class NoParamsComponent implements OnInit {

  constructor(private activatedRoute: ActivatedRoute, private router: Router) { }

  ngOnInit() {
    let type = this.activatedRoute.snapshot.params.typeId;
    let queryParams = this.activatedRoute.snapshot.queryParams;

    if (queryParams.code) {
      this.router.navigate(['../../datasources'], { queryParams: { type, code: queryParams.code, state: queryParams.state } });
    }
  }

}
